export default __webpack_public_path__ + "static/media/ThePiano_08.e7bc0225.png";